import { z } from 'zod';

//--------------------------------
// Shared Constants
//--------------------------------
const ConversationChannel = {
    Sms: 'sms',
    WebChat: 'web_chat',
};
const ConversationStatus = {
    Active: 'active',
    Processing: 'processing',
    Completed: 'completed',
    OptedOut: 'opted_out',
    TimedOut: 'timed_out',
    Escalated: 'escalated',
    Failed: 'failed',
    Idle: 'idle',
};
const MessageDirection = {
    Inbound: 'inbound',
    Outbound: 'outbound',
};
const MessageSenderType = {
    Lead: 'lead',
    AiAgent: 'ai_agent',
    System: 'system',
};
const MessageDeliveryStatus = {
    Queued: 'queued',
    Sent: 'sent',
    Delivered: 'delivered',
    Failed: 'failed',
    Undelivered: 'undelivered',
};
//--------------------------------
// ConversationLastMessage
//--------------------------------
const conversationLastMessageSchema = z.object({
    content: z.string(),
    role: z.string(),
    createdAt: z.string(),
});
//--------------------------------
// ConversationSummary
//--------------------------------
const conversationSummarySchema = z.object({
    conversationId: z.string(),
    leadId: z.string(),
    channels: z.array(z.enum(['sms', 'web_chat'])),
    status: z.enum([
        'active',
        'processing',
        'completed',
        'opted_out',
        'timed_out',
        'escalated',
        'failed',
        'idle',
    ]),
    interest: z.string(),
    customerPhone: z.string().nullable(),
    lastMessage: conversationLastMessageSchema.nullable(),
    messageCount: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
//--------------------------------
// ConversationMessage
//--------------------------------
const conversationMessageSchema = z.object({
    id: z.string(),
    conversationId: z.string(),
    channel: z.enum(['sms', 'web_chat']),
    direction: z.enum(['inbound', 'outbound']),
    body: z.string(),
    senderType: z.enum(['lead', 'ai_agent', 'system']),
    senderName: z.string(),
    createdAt: z.string(),
    status: z.enum(['queued', 'sent', 'delivered', 'failed', 'undelivered']).nullable(),
    errorCode: z.string().nullable(),
    errorMessage: z.string().nullable(),
    /** Human-readable description for system-role messages (rendered in frontend instead of raw content) */
    systemDescription: z.string().nullable(),
});

export { ConversationChannel, ConversationStatus, MessageDeliveryStatus, MessageDirection, MessageSenderType, conversationLastMessageSchema, conversationMessageSchema, conversationSummarySchema };
//# sourceMappingURL=Conversation.js.map
